import React, { Component } from "react";
import { dragNDropConstants } from "../../Globals/constants";
import { DragSource } from "react-dnd";
import Radium from "radium";
import { semanticColors } from "../../Globals/styles";

class StickyNoteDroppable extends Component {
  render() {
    const { connectDragSource } = this.props;
    return connectDragSource(
      <div style={[styles.dragable]}>
        <div style={styles.innerContainer}>
          <img
            src="/images/Drag_and_Drop.png"
            alt="dragNDrop"
            style={styles.img}
          />
          Sticky Note
        </div>
      </div>
    );
  }
}

var styles = {
  dragable: {
    height: "40px",
    lineHeight: "40px",
    borderRadius: "2px",
    width: "85%",
    textAlign: "center",
    position: "absolute",
    backgroundColor: semanticColors.warningLight,
    left: "3px",
    right: "22px",
    top: "3px",
    zIndex: 20000,
    cursor: "pointer",
  },
  innerContainer: {
    position: "relative",
  },
  img: {
    position: "absolute",
    left: "12px",
    top: "10px",
  },
};

//drag logic
const workplaceSource = {
  beginDrag() {
    return {
      isStickyNote: true,
    };
  },
  endDrag() {},
};

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  };
}

export default DragSource(
  dragNDropConstants.STICKYNOTE,
  workplaceSource,
  collect
)(Radium(StickyNoteDroppable));



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Kanban/stickyNoteDroppable.jsx